(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["can-facts"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var sec = root.matches && root.matches('[data-can-facts]') ? root : root.querySelector('[data-can-facts]');
      if (!sec || sec.__cfInit) return;
      var cards = sec.querySelectorAll('[data-cf-card]');
      var toggle = sec.querySelector('[data-cf-toggle]');
      if (!toggle || cards.length < 2) return;
      sec.__cfInit = true;
      var touched = false;

      function show(drink) {
        cards.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-cf-card') === drink); });
        toggle.querySelectorAll('[data-cf-pick]').forEach(function (b) {
          b.setAttribute('aria-pressed', b.getAttribute('data-cf-pick') === drink ? 'true' : 'false');
        });
      }
      function fromWorld(w) { return w === 'night' ? 'tini' : 'joe'; }

      toggle.hidden = false;
      sec.classList.add('cf--js');
      show(fromWorld(document.documentElement.getAttribute('data-world')));

      toggle.addEventListener('click', function (e) {
        var b = e.target.closest('[data-cf-pick]');
        if (!b) return;
        touched = true;
        show(b.getAttribute('data-cf-pick'));
      });
      document.addEventListener('cc:world', function (e) {
        if (touched) return;
        var w = e && e.detail && e.detail.world;
        if (w) show(fromWorld(w));
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["process-rail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function gateOpen() {
      try {
        if (document.cookie.split('; ').indexOf('cc_age=1') > -1) return false;
      } catch (e) {}
      if (window.ccGateClosedAt) return false;
      /* The gate markup ships [hidden] and theme.js (deferred) un-hides it,
         so "not hidden" is not "closed": until the cookie is set or the
         gate reports closing, treat any gate on the page as open. */
      var g = document.getElementById('gate');
      return !!(g && g.hasAttribute('data-age-gate'));
    }
    function motionOK() {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var save = navigator.connection && navigator.connection.saveData;
      return !reduce && !save;
    }
    var live = [];
    function pauseOthers(except) {
      live.forEach(function (c) { if (c !== except) c.video.pause(); });
    }
    function init(root) {
      var section = root.matches && root.matches('[data-process-rail]') ? root : root.querySelector('[data-process-rail]');
      if (!section) return;
      var labels = { play: 'Play video', pause: 'Pause video' };
      try {
        var raw = section.querySelector('[data-pr-labels]');
        if (raw) labels = JSON.parse(raw.textContent);
      } catch (e) {}

      section.querySelectorAll('[data-pr-video]').forEach(function (wrap) {
        if (wrap.__prInit) return;
        wrap.__prInit = true;
        var video = wrap.querySelector('video');
        var btn = wrap.querySelector('[data-pr-toggle]');
        if (!video || !btn) return;
        var ctl = { video: video, visible: false, userPaused: !motionOK() };
        live.push(ctl);
        btn.hidden = false;

        function setBtn(playing) {
          wrap.classList.toggle('is-playing', playing);
          btn.setAttribute('aria-label', playing ? labels.pause : labels.play);
        }
        function play() {
          if (gateOpen()) return;
          pauseOthers(ctl);
          var p = video.play();
          if (p && p.catch) p.catch(function () { ctl.userPaused = true; setBtn(false); });
        }
        function sync() {
          if (ctl.visible && !ctl.userPaused) play();
          else if (!video.paused) video.pause();
        }
        video.addEventListener('play', function () { setBtn(true); });
        video.addEventListener('pause', function () { setBtn(false); });
        btn.addEventListener('click', function () {
          if (video.paused) { ctl.userPaused = false; ctl.visible = true; play(); }
          else { ctl.userPaused = true; video.pause(); }
        });
        setBtn(false);

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              ctl.visible = en.isIntersecting && en.intersectionRatio >= 0.4;
              sync();
            });
          }, { threshold: [0, 0.4, 1] });
          io.observe(wrap);
        }
        document.addEventListener('cc:gate:closed', sync);
        document.addEventListener('visibilitychange', function () {
          if (document.hidden) video.pause(); else sync();
        });
      });
    }
    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
